import { useSelector } from 'react-redux';

// Components
import { U21Section } from 'app/shared/u21-ui/components';
import { AuditTrail as AuditTrailComponent } from 'app/modules/auditService/components/AuditTrail';

// Selectors
import { selectAlert } from 'app/modules/alerts/selectors';

export const AuditTrail = () => {
  const alert = useSelector(selectAlert);

  return (
    <U21Section title="Audit Trail">
      <AuditTrailComponent
        assetId={String(alert.id)}
        assetType="alert"
        assetCreatedAt={alert.created_at || ''}
      />
    </U21Section>
  );
};
